import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import s from './SkuSuggestion.scss';

const SkuSuggestion = ({ label, hint, inStock, emptyStockMessage }) => (
  <div className={cx(s.box, !inStock && s.box__emptyStock)}>
    <div className={s.row}>
      <div className={cx(s.label && !inStock && s.label__emptyStock)}>
        {label}
      </div>
      {hint && <span>{hint}</span>}
    </div>
    {!inStock && <span>{emptyStockMessage}</span>}
  </div>
);

SkuSuggestion.propTypes = {
  inStock: PropTypes.bool.isRequired,
  label: PropTypes.node,
  hint: PropTypes.string,
  emptyStockMessage: PropTypes.string,
};

SkuSuggestion.defaultProps = {
  label: undefined,
  hint: '',
  emptyStockMessage: '',
};

export default withStyles(s)(SkuSuggestion);
